module.exports = __webpack_public_path__ + "static/img/img05.8c84487.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/116/img05.png
// module id = L6Cb
// module chunks = 0